import React, { FC, useCallback, useState } from "react";

import Slider from "common/Slider/Slider";

import ProductPreview from "common/ProductPreview/ProductPreview";
import { useStore } from "store";

import { gtm } from "helpers/analytics";
import Wrapper from "./components/Wrapper/Wrapper";

import styles from "./WidgetProducts.module.scss";

type Props = {
  items: Array<Entity.Product>;
  title?: string;
  isLoading?: boolean;
  className?: string;
};

const getId = (item: Entity.Product | number) => {
  if (typeof item === "number") return item;
  return item.id;
};

const SKELETON_ITEMS = [1, 2, 3, 4];

const WidgetProducts: FC<Props> = ({ isLoading, items, title, className }) => {
  const { user } = useStore();
  const [sliderIsInit, setSliderIsInit] = useState(false);

  const onWatch = useCallback(
    ({ subject, isIntersecting, index }) => {
      if (isIntersecting) {
        gtm.watchProduct(
          subject,
          index + 1,
          title || "",
          subject?.category,
          Boolean(subject?.inStock)
        );
      }
    },
    // necessary dependency sliderIsInit
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [title, sliderIsInit]
  );

  const onClickSlide = ({ item, index }) => {
    if (item.isAdv) return;

    gtm.clickProduct(item, index + 1, title || "", item?.category);
  };

  if (user.isEmployeeMode) return null;
  if (!isLoading && !items?.length) return null;

  const currentItems = isLoading ? SKELETON_ITEMS : items;

  return (
    <div className={className}>
      <Wrapper title={title} isLoading={isLoading}>
        <Slider
          className={styles.slider}
          classNameSlide={styles.sliderSlide}
          slidesPerView="auto"
          onInit={() => {
            setSliderIsInit(true);
          }}
          touchStartPreventDefault={false}
        >
          {currentItems.map((item, index) => (
            <div key={getId(item)} className={styles.item}>
              <ProductPreview
                type={isLoading ? "horizontalSmallSkeleton" : "horizontalSmall"}
                product={item}
                onWatch={onWatch}
                onClick={() => onClickSlide({ item, index })}
                analyticsMeta={{
                  position: index + 1,
                  list: title || "",
                  category: item?.category,
                }}
              />
            </div>
          ))}
        </Slider>
      </Wrapper>
    </div>
  );
};

export default WidgetProducts;
